(function () {
  var DEFAULT_KEY = 'coca_recently_viewed_handles';

  function readHandles(storageKey) {
    try {
      var raw = window.localStorage.getItem(storageKey);
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(function (v) {
          return String(v || '').trim();
        })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function uniqueLimited(items, limit, excludedHandle) {
    var out = [];
    var seen = new Set();
    for (var i = 0; i < items.length; i++) {
      var h = items[i];
      if (!h || h === excludedHandle || seen.has(h)) continue;
      seen.add(h);
      out.push(h);
      if (out.length >= limit) break;
    }
    return out;
  }

  async function fetchCardHtml(handle) {
    var response = await fetch('/products/' + encodeURIComponent(handle) + '?view=coca-pin-card', {
      credentials: 'same-origin'
    });
    if (!response.ok) return null;
    return await response.text();
  }

  async function renderPage() {
    var page = document.querySelector('[data-coca-recently-viewed-page]');
    if (!page) return;

    var grid = page.querySelector('[data-recently-viewed-grid]');
    var empty = page.querySelector('[data-recently-viewed-empty]');
    var countEl = page.querySelector('[data-recently-viewed-count]');
    if (!grid || !empty) return;

    var limit = Number(page.getAttribute('data-limit') || 48) || 48;
    var storageKey = String(page.getAttribute('data-storage-key') || DEFAULT_KEY);
    var excludedProductHandle = String(page.getAttribute('data-excluded-product-handle') || '').trim();

    var handles = uniqueLimited(readHandles(storageKey), limit, excludedProductHandle);
    if (countEl) countEl.textContent = String(handles.length);

    if (!handles.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.innerHTML = '<p class="coca-wishlist-page__loading">Loading...</p>';

    var htmlParts = await Promise.all(
      handles.map(function (handle) {
        return fetchCardHtml(handle).catch(function () {
          return null;
        });
      })
    );

    var validParts = htmlParts.filter(Boolean);
    if (!validParts.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }

    grid.innerHTML = validParts.join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderPage();
  });

  window.addEventListener('storage', function (event) {
    if (!event.key) return;
    renderPage();
  });

  window.CocaRecentlyViewed = {
    key: DEFAULT_KEY,
    read: readHandles,
    renderPage: renderPage
  };
})();

